export enum PeriodType {
  FINANCIAL_QUARTER = 'FINANCIAL_QUARTER',
  FINANCIAL_MONTH = 'FINANCIAL_MONTH',
  FINANCIAL_YEAR = 'FINANCIAL_YEAR',

  CALENDAR_QUARTER = 'CALENDAR_QUARTER',
  CALENDAR_MONTH = 'CALENDAR_MONTH',
  CALENDAR_YEAR = 'CALENDAR_YEAR',
}
export class Period {
  periodType: PeriodType;
  year: number;
  periodNumber?: number;

  // Overload to require a periodNumber for non-annual periods
  constructor(periodType: PeriodType.CALENDAR_YEAR | PeriodType.FINANCIAL_YEAR, year: number, periodNumber?: number);
  constructor(periodType: PeriodType, year: number, periodNumber: number);
  constructor(periodType: PeriodType, year: number, periodNumber?: number) {
    this.periodType = periodType;
    this.year = year;
    this.periodNumber = periodNumber;
  }
}
